/**
 * lib/permissions.js — helpers RBAC frontend.
 *
 * Il backend include `effective_permissions: string[]` nell'oggetto user
 * su /auth/me, /auth/login e /auth/pin-login. Il frontend legge SOLO
 * quella lista: nessuna duplicazione del catalogo.
 */
export function hasPermission(user, key) {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const eff = user.effective_permissions || [];
  return eff.includes(key);
}

export function hasAny(user, keys) {
  return (keys || []).some((k) => hasPermission(user, k));
}
